import React, { useState, useRef, useEffect } from 'react';
import './Chatbot.css';

const Chatbot = () => {
  const [input, setInput] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  
  const [messages, setMessages] = useState([
    { sender: 'bot', text: 'Namaste! Welcome to Cafe ChaiY. How can I help you today? ☕' }
  ]);
  
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]); // Also scroll when typing starts

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', text: input };
    setMessages(prev => [...prev, userMessage]);
    setInput('');
    
    setIsTyping(true); // Show typing dots

    try {
      const response = await fetch('https://chai-backend-g7g4.onrender.com/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: input })
      });

      const data = await response.json();
      
      // Artificial delay to make the animation feel real
      setTimeout(() => {
        setMessages(prev => [...prev, { sender: 'bot', text: data.reply }]);
        setIsTyping(false); // Hide dots
      }, 1000); 

    } catch (error) {
      console.error("Error:", error);
      setIsTyping(false);
      setMessages(prev => [...prev, { sender: 'bot', text: "Sorry, our AI is taking a quick tea break! 🫖" }]);
    }
  };

  return (
    <div className="chatbot-wrapper">
      {isOpen ? (
        <div className="chat-window">
          {/* Header */}
          <div className="chat-header">
            <div>
              <h3 className="header-title">Ketaki</h3>
              <p className="header-status">Online</p>
            </div>
            {/* THIS IS THE NEW PREMIUM SVG CLOSE BUTTON */}
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          {/* Chat Body */}
          <div className="chat-body">
            {messages.map((msg, i) => (
              <div 
                key={i} 
                className={`message-row ${msg.sender === 'user' ? 'row-user' : 'row-bot'}`}
              >
                <div className={`message-bubble ${msg.sender === 'user' ? 'user-message' : 'bot-message'}`}>
                  {msg.text}
                </div>
              </div>
            ))}

            {/* Typing Dots inside the chat body */}
            {isTyping && (
              <div className="message-row row-bot">
                <div className="typing-container">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            )}
            
            <div ref={messagesEndRef} />
          </div>

          {/* Footer Input */}
          <div className="chat-footer">
            <input 
              className="chat-input"
              type="text" 
              value={input} 
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
              placeholder="Ask about our menu..."
            />
            <button onClick={sendMessage} className="send-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </button>
          </div>
        </div>
      ) : (
        <button onClick={() => setIsOpen(true)} className="chat-toggle-btn">
          ☕
        </button>
      )}
    </div>
  );
};

export default Chatbot;
